/* tslint:disable */
/* eslint-disable */
/**
 * Authentication-API
 * This API allows strong authentication with LuxTrust.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TokenResponse
 */
export interface TokenResponse {
    /**
     * The refesh token issued by the authorization server
     * @type {string}
     * @memberof TokenResponse
     */
    refreshToken: string;
    /**
     * The ID Token is represented as a JSON Web Token (JWT)
     * @type {string}
     * @memberof TokenResponse
     */
    idToken: string;
}

/**
 * Check if a given object implements the TokenResponse interface.
 */
export function instanceOfTokenResponse(value: object): value is TokenResponse {
    if (!('refreshToken' in value) || value['refreshToken'] === undefined) return false;
    if (!('idToken' in value) || value['idToken'] === undefined) return false;
    return true;
}

export function TokenResponseFromJSON(json: any): TokenResponse {
    return TokenResponseFromJSONTyped(json, false);
}

export function TokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'refreshToken': json['refresh_token'],
        'idToken': json['id_token'],
    };
}

export function TokenResponseToJSON(json: any): TokenResponse {
    return TokenResponseToJSONTyped(json, false);
}

export function TokenResponseToJSONTyped(value?: TokenResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'refresh_token': value['refreshToken'],
        'id_token': value['idToken'],
    };
}

